import { ClientStatus } from "@shared/types";

export const PORTFOLIO_DATA_CLIENT_HEADER = "client";
export const PORTFOLIO_DATA_EXCHANGE_HEADER = "exchange";
export const PORTFOLIO_DATA_CLIENTS_HEADER = "clients";
export const PORTFOLIO_DATA_EXCHANGES_HEADER = "exchanges";

export const INACTIVE_ACCOUNT_STATUSES = new Set([
  ClientStatus.DEACTIVATED_BY_USER,
  ClientStatus.DEACTIVATED_BY_SYSTEM,
  ClientStatus.DEACTIVATED_DUE_TO_INACTIVITY,
]);

export const DEMO_ACCOUNT_DEFAULT_INITIAL_FUNDS = 100000;
export const DEMO_ACCOUNT_INITIAL_FUNDS_RANGE = [100, 1000000];
